import { gql, useQuery } from '@apollo/client';

export type SkillLevelListData = {
  skillLevelList: string[];
};

const GET_SKILL_LEVEL_LIST = gql`
  query GetSkillLevelList {
    skillLevelList
  }
`;

type UseSkillLevelsDictionaryReturnType = {
  data: SkillLevelListData | undefined;
  loading: boolean;
};

export const useSkillLevelDictionary =
  (): UseSkillLevelsDictionaryReturnType => {
    const { data, loading, error } =
      useQuery<SkillLevelListData>(GET_SKILL_LEVEL_LIST);

    if (error || !data) {
      // throw error;
    }

    return { data, loading };
  };
